import { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../../app/components/ui/card";
import { api, type AdminDashboardResponse } from "../../lib/api";
import { useAuth } from "../../providers/AuthProvider";
import { mapRecentActivityToFeed } from "../../app/components/dashboard/mapRecentActivityFeed";
import type { ActivityFeedItem } from "../../app/components/dashboard/mapRecentActivityFeed";
import { ActivityFeedRow } from "../../app/components/dashboard/ActivityFeedRow";

export function AdminRecentActivityPage() {
  const { token } = useAuth();
  const [items, setItems] = useState<ActivityFeedItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    (async () => {
      try {
        const res = await api.dashboard.getAdmin({ token });
        if (cancelled) return;
        const json = res as AdminDashboardResponse;
        const rows = mapRecentActivityToFeed(json.data?.recent_activity ?? []);
        setItems(rows);
      } catch {
        setItems([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-3xl font-semibold text-foreground mb-1">Recent activity</h1>
        <p className="text-muted-foreground">Platform-wide sales, inventory, and purchase orders.</p>
      </div>

      <Card className="border-0 shadow-sm">
        <CardHeader>
          <CardTitle>Activity log</CardTitle>
        </CardHeader>
        <CardContent>
          {loading ? (
            <p className="text-sm text-muted-foreground py-8 text-center">Loading…</p>
          ) : items.length === 0 ? (
            <p className="text-sm text-muted-foreground py-8 text-center">No activity yet.</p>
          ) : (
            <div className="space-y-3 max-h-[min(70vh,720px)] overflow-y-auto pr-1">
              {items.map((activity, index) => (
                <ActivityFeedRow key={activity.id} activity={activity} index={index} delay={0} />
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
